import {ActionInterface} from '../types/mx/actions';

export const CLOSE_MODAL_ACTION: ActionInterface = {
    name: 'CLOSE_MODAL_ACTION',
    action: (isFirstModal = true) => ({
        isFirstModal,
        type: CLOSE_MODAL_ACTION.name
    })
};

export const OPEN_MODAL_DATA_ACTION: ActionInterface = {
    name: 'OPEN_MODAL_DATA_ACTION',
    action: (header, content, footer, options) => ({
        header, content, footer, options,
        type: OPEN_MODAL_DATA_ACTION.name
    })
};
